<template>
    <div ref="list" class="tw-space-y-4 tw-mt-4">
        <div class="tw-grid tw-grid-cols-1 sm:tw-grid-cols-2 xl:tw-grid-cols-3 tw-gap-8">
            <div
                v-for="feedback in normalizedData.slice(0, maxAmountVisible)"
                :key="feedback._id"
                class="mouseover-parent clickable feedback-list-item"
                tabindex="0"
                @click="
                    $router.push(
                        `/profile/${$route.params.userId || currentUser._id}/feedback/${
                            feedback._id
                        }`,
                    )
                "
                @keyup.enter="
                    $router.push(
                        `/profile/${$route.params.userId || currentUser._id}/feedback/${
                            feedback._id
                        }`,
                    )
                "
            >
                <l-feedback-list-item :feedback="feedback" />
            </div>
        </div>

        <l-user-profile-load-more
            :items="normalizedData"
            :value.sync="maxAmountVisible"
            :max-amount-visible="6"
            :scroll-to-element="$refs.list"
        />
    </div>
</template>

<script>
import { mapGetters } from "vuex";
import teamPicture from "@/img/icons/team-icon.png";

import LFeedbackListItem from "@/components/LFeedbackListItem";
import LUserProfileLoadMore from "@/components/LUserProfile/LUserProfileLoadMore";

export default {
    components: {
        LFeedbackListItem,
        LUserProfileLoadMore,
    },
    props: {
        feedbackEntries: {
            type: Array,
            default: () => [],
        },
    },
    data() {
        return {
            maxAmountVisible: 6,
        };
    },
    computed: {
        ...mapGetters({
            currentUser: "users/current/user",
        }),
        normalizedData() {
            if (!Array.isArray(this.feedbackEntries)) return [];

            return this.feedbackEntries.map(feedback => ({
                ...feedback,
                thanksNoteReceivers: feedback.thanksNoteReceivers?.map(receiver => ({
                    ...receiver,
                    picture:
                        (!receiver.picture || receiver.picture == "/img/icons/user_small.png") &&
                        receiver.name
                            ? teamPicture
                            : receiver.picture,
                })),
            }));
        },
    },
};
</script>
